module.exports = __webpack_public_path__ + "img/hn.e0437018.jpg";